import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ManagementCardContent.css';

const API_URL = process.env.REACT_APP_API_URL;

const ManagementCardContent = (props) => {
    const navigate = useNavigate();

    const handleClick = (event) => {
        const buttonName = event.currentTarget.name;
        
        switch (buttonName) {
            case 'update-profile': {
                props.setIsLoading(true);

                const handleUpdateProfile = async () => {
                    try {
                        const token = localStorage.getItem('token');
                        const response = await fetch(`${API_URL}/accounts/golestan-profile`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Token ${token}`,
                                'Content-Type': 'application/json',
                            },
                        });
                        if (response.ok) {
                            props.setModal({
                                isVisible: true,
                                message: 'پروفایل با موفقیت بروزرسانی شد',
                                type: 'success',
                            });
                        } else {
                            const errorData = await response.json();
                            props.setModal({
                                isVisible: true,
                                message: errorData.error,
                                type: 'error',
                            });
                        }
                    } catch (error) {
                        props.setModal({
                            isVisible: true,
                            message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                            type: 'error',
                        });
                    } finally {
                        props.setIsLoading(false);
                    }
                };
                handleUpdateProfile();
                break;
            }

            case 'update-activities': {
                props.setIsLoading(true);

                const handleUpdateActivities = async () => {
                    try {
                        const token = localStorage.getItem('token');
                        const response = await fetch(`${API_URL}/resume-management/golestan-resume`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Token ${token}`,
                                'Content-Type': 'application/json',
                            },
                        });
                        if (response.ok) {
                            props.setModal({
                                isVisible: true,
                                message: 'پروفایل با موفقیت بروزرسانی شد',
                                type: 'success',
                            });
                        } else {
                            const errorData = await response.json();
                            props.setModal({
                                isVisible: true,
                                message: errorData.error,
                                type: 'error',
                            });
                        }
                    } catch (error) {
                        props.setModal({
                            isVisible: true,
                            message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                            type: 'error',
                        });
                    } finally {
                        props.setIsLoading(false);
                    }
                };
                handleUpdateActivities();
                break;
            }

            case '': {
                navigate(props.href);
                break;
            }
        };
    };

    return (
        <div className="card-link-container medium-text">
            <button className="card-link medium-text" name={props.name} onClick={(event) => handleClick(event)}>
                {props.method}
            </button>
        </div>
    );
};

export default ManagementCardContent;
